export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/weWingmanWorker.worker.4903acb5.worker.js");
}
